module.exports = __webpack_public_path__ + "img/Stepping APA 1980.8e94ae3d.jpg";